module.exports = __webpack_public_path__ + "img/logo_navbar.5440115c.png";